<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
        <el-select
            size="medium"
            v-model="searchForm.coinId"
            placeholder="请选择币种"
            @change="getTableList"
            clearable 
            >
            <el-option
                v-for="item in coinList"
                :key="item.coinId"
                :label="item.coinName"
                :value="item.coinId"
            ></el-option>
        </el-select>

        <el-cascader
        v-model="selectedTypeVal"
        :options="selectType"
        :props="{ expandTrigger: 'hover' }"
        clearable
        @change="selectTypeChange"></el-cascader>

   

      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/coinUser/userBalanceChange/export?startTime='+searchForm.startTime 
            + '&endTime='+searchForm.endTime
            + '&coinId=' + searchForm.coinId
            + '&page=' + searchForm.page
            + '&pageSize=' + searchForm.pageSize
            + '&subType=' + searchForm.subType
            + '&type=' + searchForm.type
        "
        style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="userId"
      width="110"
      label="用户ID">
    </el-table-column>
    <el-table-column
      prop="coinName"
      label="币种名称">
    </el-table-column>
    <el-table-column
      prop="changeType"
      label="收支类型">
      <template slot-scope="scope">
        <span>{{scope.row.changeType === 1 ? '收入':'支出'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="amount"
      label="变动金额">
        <template slot-scope="scope">
           <span>{{$selfFunc.toNonExponential(scope.row.amount,4)}}</span>
        </template>
    </el-table-column>
    
    <el-table-column
      prop="beforeBalance"
      label="变动前余额">
      <template slot-scope="scope">
           <span>{{$selfFunc.toNonExponential(scope.row.beforeBalance,4)}}</span>
       </template>
    </el-table-column>
    <el-table-column
      prop="afterBalance"
      label="变动后余额">
       <template slot-scope="scope">
           <span>{{$selfFunc.toNonExponential(scope.row.afterBalance,4)}}</span>
       </template>
    </el-table-column>
    <el-table-column
      prop="type"
      label="类型">
      <template slot-scope="scope">
        <span>{{typeFunc(scope.row.type)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="subType"
      label="子业务类型">
      <template slot-scope="scope">
        <span>{{subTypeFunc(scope.row.type,scope.row.subType)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="orderId"
      label="订单ID">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="创建时间">
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[10, 20, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      selectedTypeVal: [],
      selectType: [
          { value: 1, label: '充值'},
          { value: 2, label: '提现', children: [{ value: 1, label: '发起提现扣除'},{ value: 2, label: '提现失败退回'}]},
          { value: 3, label: '质押退回'},
          { value: 4, label: '下单支付',children: [{ value: 1, label: '下单扣除'},{ value: 2, label: '订单失败或拒绝退回'}]},
      ],
      selectSubType: [],

      searchForm:{
        page:1,
        pageSize:20,
        startTime: '',
        endTime: '',

        coinId: "",
        orderId: null,
        subType: '',//业务子类型
                    // 提现子业务类型 - 发起提现扣除            1
                    // 提现子业务类型 - 提现失败退回            2
                    // 下单子业务类型 - 下单扣除          1
                    // 下单子业务类型 - 订单失败或拒绝退回         2
        type: "",//业务类型 1-充值，2-提现，3-质押退回，4-下单支付
        userId: null,
      },
      tableData: [],
      url: window.g.host,
      coinList: []
    };
  },
  created() {
    this.getTableList()
    this.getCoinList()
  },
  methods: {
    async getCoinList() {
        let res = await this.$http.getCoinlistApi()
        if(res) {
            this.coinList = res.data
        }
    },
    selectTypeChange() {
        this.searchForm.type = this.selectedTypeVal[0]
        if(this.selectedTypeVal[1]) {
            this.searchForm.subType = this.selectedTypeVal[1]
        }else {
            this.searchForm.subType = ''
        }
    },
    subTypeFunc(type,subType) {
        let str = '--'
        if(type === 2) {//提现
            if(subType === 1) str = '发起提现扣除'
            if(subType === 2) str = '提现失败退回'
        }
        if(type === 4) {//下单支付
            if(subType === 1) str = '下单扣除'
            if(subType === 2) str = '订单失败或拒绝退回'
        }
        return str
    },  
    typeFunc(type) {
        let str = '--'
        switch (type) {
            case 1:
                str = '充值'
                break;
            case 2:
                str = '提现'
                break;
            case 3:
                str = '质押退回'
                break;
            case 4:
                str = '下单支付'
                break;
            default:
                break;
        }
        return str
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.userBalanceChangePageApi({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
